module.exports = __webpack_public_path__ + "static/media/pauseIcon.6587792e.svg";